import {
    BulletList,
    Card,
    LabelBody,
    LabelHeader4,
    LabelHeader5,
    SecondaryButton,
    Spacer,
    Textarea,
} from '../../components';
import { IllustrationPenPaper } from '../../icons';
import { useSyncedState } from '../../useSyncedState';
import { Module4Exercise1Graph } from './Module4Exercise1Graph';
import { Rating } from './Rating';

type Page5Props = {
    importantAreas: string[];
    ratingsImportance: Rating[];
    ratingsTime: Rating[];
    reflection: string;
    onContinue: (reflection: string) => void;
};
export function Page5({
    importantAreas,
    ratingsImportance,
    ratingsTime,
    reflection: _ref,
    onContinue,
}: Page5Props) {
    const [reflection, setReflection] = useSyncedState(_ref);
    return (
        <>
            <LabelHeader4>Her er dit kompas</LabelHeader4>
            <LabelBody className="mb-30 mt-10">
                Her har du dit indre kompas med dine valgte livsområder. For
                hvert livsområde kan du sammenligne vigtigheden med mængden af
                tid, du bruger.
            </LabelBody>
            <Module4Exercise1Graph
                importantAreas={importantAreas}
                ratingsImportance={ratingsImportance}
                ratingsTime={ratingsTime}
            />
            <Card className="my-30">
                <IllustrationPenPaper />
                <LabelHeader5 className="mb-10 mt-20">
                    Hvordan er balancen?
                </LabelHeader5>
                <LabelBody>
                    For at føle dig mindre presset er det smart at bruge tid på
                    det, der virkelig betyder noget for dig.
                </LabelBody>
                <LabelBody>
                    Kig nu på dit kompas og tænk over:
                    <BulletList
                        items={[
                            'Hvor bruger du meget tid på noget, der ikke føles så vigtigt?',
                            'Hvor bruger du tid på noget, der føles meget vigtigt?',
                            'Er der noget ved kompasset, der overrasker dig, eller er det som forventet?',
                        ]}
                    />
                </LabelBody>
                <Textarea
                    placeholder="Skriv her..."
                    text={reflection}
                    onChangeText={setReflection}
                />
                <LabelBody>
                    Dit svar bliver gemt i logbogen, når du fortsætter.
                </LabelBody>
            </Card>
            <Spacer />
            <SecondaryButton onClick={() => onContinue(reflection)}>
                Afslut øvelsen
            </SecondaryButton>
        </>
    );
}
